export const WINDOW_BOUNDS_OFFSET = 20



// WEBPACK FOOTER //
// ./components/Popover/constants.js